import APIClient from '@/shared/http/clients/api'

const resourceName = 'po'
const APIBusinessCommon = process.env.APIBaseURLBusinessCommon

const GetByWork = (data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}`, data, config)

const PurchaseOrderRepository = {
  GetByWork
}

export default PurchaseOrderRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/purchaseorder.js